import React from 'react'
import styled from 'styled-components'
import { Row, Col } from 'react-bootstrap'

export default () => (
  <Row>
    <Col sm={{ span: 8, offset: 2 }}>
      <h2 style={{ textAlign: 'center', margin: '20px auto' }}>
        {' '}
        Мы поставляем:
      </h2>
      <Ul>
        <br />
        <Li>• Мебель</Li>
        <Li>• Освещение </Li>
        <Li>• Сантехника</Li>
        <Li>• Декор</Li>
        <Li>• Керамика</Li>
        <Li>• Отделочные материалы</Li>
      </Ul>
    </Col>
  </Row>
)

const Ul = styled.ul`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
`
const Li = styled.li`
  font-weight: bold;
  opacity: 1;
  text-align: center;
  font-size: 22px;
  margin: 0 20px 10px;
  @media (max-width: 800px) {
    font-size: 16px;
    margin: 0 10px 5px;
  }
`
